export default __webpack_public_path__ + "static/media/Sana.add42b23.mp3";